

export enum GameServerCode {
    AU = "AU",
    NL = "NL",
    UK = "UK",
};

// const GameServerKeys = {
//     KEY_ID: 'server-id',
//     KEY_CODE: 'server-code',
//     KEY_DOMAIN: 'server-domain',
//     KEY_HOST_LIST: 'server-host-list',
//     KEY_HOST_INDEX: 'server-host-index',
//     KEY_API: 'server-api',
// } as const;

// export const GameServerId = {
//     NONE: -1,
//     TEST: 0,
//     AU: 1,
//     NL: 2,
//     UK: 3,
//     // BETA: 9,
// }

export class GameServer {
    code = "";
    domain = "";

    urls: Array<string> = [];
    hostIndex = 0; // which server did we connect to

    hostCount = 0;

    api = "";
}
